import {
  GT_ITI_BUILDER_VIEW,
  GT_ITI_BUILDER_VISIBLE_COLS,
  GT_LOCAL_SETTINGS,
} from "../constants/settings";
import layoutSettings from "../constants/layout-settings";
export const isAuthenticated = (state) => state.apiKey !== null;
export const userConfig = (state) => state.userConfig;
export const userEmail = (state) =>
  state.userConfig ? state.userConfig.email : "";
export const agentId = (state) => state.agentId;
export const itineraryAgentId = (state) => state.itineraryAgentId;
export const itineraryAgentName = (state) => state.itineraryAgentName;
export const itineraryAgentCurrency = (state) => state.itineraryAgentCurrency;
export const itineraryAgentDepartment = (state) =>
  state.itineraryAgentDepartment;
export const itineraryDepartment = (state) => state.itineraryDepartment;
export const userId = (state) => state.userId;
export const owner = (state) => state.owner;
export const appToolbarInfo = (state) => state.appToolbarInfo;
export const appVersion = (state) => state.appVersion;
export const appSnackbar = (state) => state.appSnackbar;
export const inactivityTime = (state) => state.inactivityTime;
export const hasAccessTo =
  (state) =>
  (settingToCheck, defaultVal = false) => {
    const groupName = settingToCheck.split(":")[0];
    const settingName = settingToCheck.split(":")[1];
    if (state.userConfig && state.userConfig.accessSettings) {
      const setting = state.userConfig.accessSettings.find(
        (s) => s.groupName == groupName && s.settingName == settingName
      );
      if (setting) {
        return setting.settingValue;
      } else {
        return defaultVal;
      }
    }
    return false;
  };
// AI modules are switched on per tenant (Owner access settings), not per user (#11497).
export const hasAiModule = (state) => (moduleName) =>
  !!(
    state.userConfig &&
    state.userConfig.aiModules &&
    state.userConfig.aiModules.includes(moduleName)
  );
export const localSettings = (state) => (key, defaultVal) => {
  if (state.localSettings) {
    return state.localSettings.hasOwnProperty(key)
      ? state.localSettings[key]
      : layoutSettings[key]
      ? layoutSettings[key]
      : defaultVal;
  } else {
    return defaultVal;
  }
};
export const isCPS = (state) => {
  const cpsDomains = [
    "cpstest.pinkelephantinternational.com",
    "cpslive.pinkelephantinternational.com",
    "localhost",
  ];
  return cpsDomains.includes(window.location.hostname);
};



// WEBPACK FOOTER //
// ./src/store/getters.js